export const materialsHero = {
  title: '使用教材',
  titleEn: 'MATERIALS',
  lead: '学びを支えるのは、協会監修による体系的な教科書群です。在学中の学びだけでなく、卒業後も長く手元で参照できる一生ものの資料として編まれています。',
};

export const materialPhilosophy = {
  title: '教材の考え方',
  titleEn: 'Our Approach to Materials',
  description1: '教材は、在学中だけのものではありません。実務に直結する事例を豊富に収め、卒業後も長く参照できる一生ものの資料として編まれています。協会の知見を結集し、執事という職業の本質を学問として体系化した、日本で唯一の本格的な執事育成機関ならではの教科書群です。',
  description2: '授業では、教科書の該当箇所を事前学習としてご案内し、対面の時間を実技と質疑に充てる反転学習的な進め方を取り入れています。また、卒業生が実務で参照することを想定し、索引や用語集の充実を教材設計の方針としています。なお、電子版（PDF）のご提供につきましては、現在検討中です。',
};

export const textbookGroups = [
  {
    key: 'essential',
    label: 'E群 基礎教科書（全コース共通・5冊）',
    note: '全コース共通で提供',
    books: [
      {
        code: 'E1',
        title: '執事学入門：歴史・文化・職業倫理',
        titleEn: 'Introduction to Butlering: History, Culture & Professional Ethics',
        description: '英国発祥の執事文化の歴史から現代に至るまでの変遷、執事としての職業倫理と心構えを学ぶ入門書。全コース共通の基本テキストです。',
        color: 'accent',
        imageSeq: 'textbook-01',
      },
      {
        code: 'E2',
        title: 'ハウスキーピングの理論と実践',
        titleEn: 'Housekeeping Theory & Practice',
        description: '邸宅の清掃・洗濯・衣類管理から家政運営の基礎理論まで、ハウスキーピングの実務を体系的に学ぶ一冊です。',
        color: 'accent',
        imageSeq: 'textbook-02',
      },
      {
        code: 'E3',
        title: 'サービスの基本とおもてなしの心',
        titleEn: 'Fundamentals of Service & the Spirit of Hospitality',
        description: 'テーブルマナー、来客応対、おもてなしの精神を軸に、サービスの基本所作を身につける実践テキストです。',
        color: 'accent',
        imageSeq: 'textbook-03',
      },
      {
        code: 'E4',
        title: 'コミュニケーションとビジネスマナー',
        titleEn: 'Communication & Business Etiquette',
        description: '敬語・言葉遣いから電話応対、ビジネス文書まで、執事に求められる対人スキルとマナーを網羅します。',
        color: 'accent',
        imageSeq: 'textbook-04',
      },
      {
        code: 'E5',
        title: '英国紳士の教養とたしなみ',
        titleEn: 'The English Gentleman\'s Refinement',
        description: '英国紳士文化に根差した教養、身だしなみ、会話術など、品格あるたしなみを学ぶ一冊です。',
        color: 'accent',
        imageSeq: 'textbook-05',
      },
    ],
  },
  {
    key: 'advanced',
    label: 'A群 応用教科書（アドバンス・マスター・5冊）',
    note: 'アドバンスはE群5冊も提供（計10冊）',
    books: [
      {
        code: 'A1',
        title: '家政管理と財務運営',
        titleEn: 'Household Administration & Financial Management',
        description: '家計簿・予算管理から外部業者との折衝まで、邸宅運営における財務・家政管理の実務を学びます。',
        color: 'accent',
        imageSeq: 'textbook-a1',
      },
      {
        code: 'A2',
        title: 'ビジネスサポートと秘書業務',
        titleEn: 'Business Support & Secretarial Duties',
        description: 'スケジュール管理、文書作成、来客対応など、雇主のビジネスを支える秘書的実務を体系化しています。',
        color: 'accent',
        imageSeq: 'textbook-a2',
      },
      {
        code: 'A3',
        title: '食事サービスとテーブルマナー',
        titleEn: 'Dining Service & Table Manners',
        description: 'フォーマルディナーの提供手順、ワイン・ティーサービス、テーブルコーディネートを学ぶ実践書です。',
        color: 'accent',
        imageSeq: 'textbook-a3',
      },
      {
        code: 'A4',
        title: 'イベント企画と空間演出',
        titleEn: 'Event Planning & Spatial Design',
        description: 'パーティーやレセプションの企画運営、空間演出、装花・照明までを扱う応用テキストです。',
        color: 'accent',
        imageSeq: 'textbook-a4',
      },
      {
        code: 'A5',
        title: 'ライフスタイル管理と特別サポート',
        titleEn: 'Lifestyle Management & Special Support',
        description: '雇主の日常生活全般のマネジメントと、個別ニーズに応じた特別なサポート技術を学びます。',
        color: 'accent',
        imageSeq: 'textbook-a5',
      },
    ],
  },
  {
    key: 'master',
    label: 'M群 専門教科書（マスター限定・5冊）',
    note: 'マスターは全15冊を提供',
    books: [
      {
        code: 'M1',
        title: '国際プロトコルと各国文化',
        titleEn: 'International Protocol & Cross-Cultural Understanding',
        description: '各国の外交儀礼・文化的タブー・国際的なマナーを収録し、グローバルに活躍する知識を提供します。',
        color: 'accent',
        imageSeq: 'textbook-m1',
      },
      {
        code: 'M2',
        title: '社交技術とエスコート',
        titleEn: 'Social Skills & Escort Technique',
        description: '社交の場でのふるまい、エスコート技術、会話術など、上級執事に求められる社交スキルを学びます。',
        color: 'accent',
        imageSeq: 'textbook-m2',
      },
      {
        code: 'M3',
        title: 'トラベルサポートと移動管理',
        titleEn: 'Travel Support & Transportation Management',
        description: '旅程の手配から車両・移動手段の管理まで、雇主の移動を支えるトラベルサポートの実務を学びます。',
        color: 'accent',
        imageSeq: 'textbook-m3',
      },
      {
        code: 'M4',
        title: '危機管理とトラブル対応',
        titleEn: 'Crisis Management & Incident Response',
        description: '医療緊急時、自然災害、セキュリティ事案など、邸宅で起こりうる危機への対応力を養います。',
        color: 'accent',
        imageSeq: 'textbook-m4',
      },
      {
        code: 'M5',
        title: 'VVIPサービスとマネジメント',
        titleEn: 'VVIP Service & Management',
        description: '最上級の顧客層に向けたサービス設計とスタッフマネジメント、執事としての総合力を極める最終巻です。',
        color: 'accent',
        imageSeq: 'textbook-m5',
      },
    ],
  },
];

export const courseMaterialsTable = {
  title: 'コース別の使用教材',
  titleEn: 'Textbooks by Course',
  description: 'コースにより使用する教科書の冊数が異なります。教材費はすべて受講料に含まれており、別途のご負担はありません。',
  courses: [
    {
      name: 'エッセンシャル',
      nameEn: 'Essential',
      pages: '5冊',
      textbooks: 'E1〜E5',
      href: '/courses/essential',
      note: '入門に必要な基礎知識をE群5冊で凝縮',
    },
    {
      name: 'アドバンス',
      nameEn: 'Advanced',
      pages: '計10冊',
      textbooks: 'E1〜E5, A1〜A5',
      href: '/courses/advanced',
      note: '実務に直結するA群5冊を加え専門性を強化',
    },
    {
      name: 'マスター',
      nameEn: 'Master',
      pages: '全15冊',
      textbooks: 'E1〜E5, A1〜A5, M1〜M5',
      href: '/courses/master',
      note: '教材全15冊で最高水準の知識を網羅',
    },
  ],
};

export const materialUpdates = {
  title: '教材の更新',
  titleEn: 'Updates & Revisions',
  description: '協会監修の教科書は、定期的に内容を見直し、最新の知見や事例を反映していく予定です。社会の変化やサービスの潮流を踏まえ、常に最良の学びを提供できるよう努めてまいります。改訂時期や内容の詳細は、確定し次第お知らせページにてご案内します。',
};

export const materialsFaqs = [
  {
    question: '教材は何冊ありますか？',
    answer: '協会監修の教科書が全15冊あります。エッセンシャルはE群5冊、アドバンスはE群+A群の計10冊、マスターは全15冊を使用します。',
  },
  {
    question: '教材費は別途かかりますか？',
    answer: '教材費は受講料に含まれています（別途のご負担はありません）。',
  },
  {
    question: '卒業後も使えますか？',
    answer: 'はい。実務に直結する内容のため、修了後の参考資料としてもご活用いただけます。',
  },
];

export const materialsRelatedPages = [
  {
    title: '習得スキル一覧',
    description: '身につく5つのスキル領域',
    href: '/skills',
  },
  {
    title: '実践トレーニング',
    description: '実技とロールプレイング中心の訓練',
    href: '/training',
  },
  {
    title: 'カリキュラム概要',
    description: '学びの全体像と進め方',
    href: '/curriculum',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
];